// extracted by mini-css-extract-plugin
module.exports = {"title":"CreateSubOrganizationStyle_title__9SCD2","sub_text":"CreateSubOrganizationStyle_sub_text__1S4Wy","button":"CreateSubOrganizationStyle_button__3AzMc"};